import React from "react";
import { Outlet } from "react-router-dom";
import './logs.scss';

const LogsOutlet = () => {
    return (
        <div className="logs">
            <Outlet />
        </div>
    )
}

export default LogsOutlet;